module.exports = __webpack_public_path__ + "static/media/slider-3.0fb93455.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slider-3.jpg
// module id = 1189
// module chunks = 33